import { Component } from '@angular/core';
import { ModalService } from 'src/app/core/services/modal.service';
import { MigrationNoticeComponent } from '../migration-notice/migration-notice.component';
import { UtilsService } from 'src/app/core/services/utils.service';
import { AppUpdateSnackBarComponent } from 'src/app/pages/containers/components/app-update-snack-bar/app-update-snack-bar.component';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { SessionService } from 'src/app/core/services/session.service';
import { IGroup } from 'src/app/core/models/Group';
import { GroupType } from 'src/app/core/enums/enums';

@Component({
  selector: 'app-migration-banner',
  templateUrl: './migration-banner.component.html',
  styleUrls: ['./migration-banner.component.scss'],
})
export class MigrationBannerComponent {
  device: string;
  currentGroup: IGroup;
  GroupType = GroupType;
  hcpNewAppUrl = 'https://hcp.v4.kimbocare.com/';

  constructor(
    private modalService: ModalService,
    private utilsService: UtilsService,
    private snackBar: MatSnackBar,
    private sessionService: SessionService
  ) {
    this.device = this.utilsService.getMobileOperatingSystem();
    this.currentGroup = this.sessionService.getCurrentRole()?.group;
  }

  openMigrationPopup() {
    if (this.currentGroup?.type === GroupType.Hcp) {
      window.open(this.hcpNewAppUrl, '_blank');
    } else {
      if (this.device !== 'Android' && this.device !== 'iOS') {
        this.modalService.openModal(MigrationNoticeComponent, {
          height: 'auto',
          width: '1000px',
          data: {
            migrationDate: '06/08/2025',
            blocageDate: '24/07/2025',
            caller: '_BANNER',
          },
          disableClose: true,
        });
      } else {
        const snack = this.snackBar.openFromComponent(
          AppUpdateSnackBarComponent
        );

        snack.afterDismissed().subscribe(() => {
          window.location.reload();
        });

        snack.onAction().subscribe(() => {
          window.location.reload();
        });
      }
    }
  }
}
